import React, { Component } from 'react';

import { PropTypes } from 'prop-types';
import { TransportAuthorityEditions } from './transportAuthorityEditions/TransportAuthorityEditions';
import { ProviderEditions } from './providerEditions/ProviderEditions';

export class Editions extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
    }

    // ---------------------------

    isTransportAuthorityData() {
        const { selectedProvider } = this.context;

        return undefined !== selectedProvider && selectedProvider.startsWith("0:");
    }

    // ---------------------------

    renderEditions() {
        if (this.isTransportAuthorityData()) {
            return <TransportAuthorityEditions title="Edições" />
        }

        return <ProviderEditions title="Edições" />
    }

    render() {
        return (
            <div>
                {this.renderEditions()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/editions/Editions.js